<!--
 * @Author: Linpengze
 * @Date: 2022-04-26 17:21:31
 * @LAstEditors: 林鹏泽
 * @LastEditTime: 2022-04-26 17:21:31
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\productionInfoManagement\classificationManagement.vue
-->
<template>
    <div class="app-container">
        <!-- 工具栏 -->
        <div class="topbar">
            <div><el-button size="small" type="primary" @click.stop="goBack()">返  回</el-button></div>
            <el-button type="primary" size="small" @click.stop="conditionDialogVisible = true">添加分类</el-button>
        </div>

        <!-- 内容 -->
        <el-table
                :data="tagsList"
                :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%; margin-bottom: 20px"
        >
            <el-table-column label="排序" prop="sort" align="center" />
            <el-table-column label="分类名称" prop="showName" align="center" />
            <el-table-column label="父分类" prop="parentID" align="center" >
                <template slot-scope="scope">{{scope.row.parentID === 0 ? "-":"" }}</template>
            </el-table-column>
            <el-table-column label="是否启用" align="center" prop="isEnable" width="130">
                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.isEnable"
                            active-color="#13ce66"
                            :active-value="true"
                            :inactive-value="false"
                            @change="onMarkChange(scope.row,$event)"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="small"  @click="handleUpdateCondition(scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDeleteRow(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 更新对话框 -->
        <el-dialog
                title="编辑产品分类"
                :visible.sync="editDialogVisible"
                width="20%"
        >
            <el-form ref="formRef" :model="editConditionModel" label-width="40px">
            <el-form-item label="名称" prop="showName">
                <el-input
                        v-model="editConditionModel.showName"
                        placeholder="请输入名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number
                        size="small"
                        v-model="editConditionModel.sort"
                        :min="1"
                ></el-input-number>
            </el-form-item>温馨提示：<br>排序值决定分类在管理页顶部<br>分类导航的显示顺序。<br>数值越小排序越靠前。
        </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click.stop="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" size="small" @click.stop="editCondition()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 新增类别对话框 -->
        <el-dialog
                title="新增产品资料分类"
                :visible.sync="conditionDialogVisible"
        >
            <el-form ref="formRef" :model="conditionModel" label-width="150px">
                <el-form-item label="类别名称" prop="showName" required>
                    <el-input
                            v-model="conditionModel.showName"
                            placeholder="请输入名称"
                            style="width:202px"
                    ></el-input>
                </el-form-item>
<!--                <el-form-item label="绑定字段" prop="fieldName" required>-->
<!--                    <el-input-->
<!--                            v-model="conditionModel.fieldName"-->
<!--                            :placeholder=conditionModel.fieldName-->
<!--                            style="width:202px"-->
<!--                            disabled-->
<!--                    ></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="是否启用" prop="enable" required>
                    <el-radio-group v-model="conditionModel.isEnable" >
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number size="small" v-model="conditionModel.sort" :min="1"></el-input-number>
                    <br>温馨提示：排序值决定分类在管理页顶部分类导航的显示顺序。<br>数值越小排序越靠前。
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click.stop="conditionDialogVisible = false">取 消</el-button>
                <el-button type="primary" size="small" @click.stop="addCondition()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {getConditionList,getConditionDetail,updateCondition,deleteCondition,addCondition} from "@/api/system/CSDocument/file";

    export default {
        name: "",

        data() {
            return {
                tagsList: [],
                editDialogVisible:false, //编辑筛选条件加载开关
                conditionDialogVisible: false,
                dialogTitle: "",
                categories: [
                    { id: "001", name: "超声", order: 1, show: true },
                    { id: "002", name: "I-BUS", order: 2, show: true },
                    { id: "003", name: "X-RAY", order: 3, show: true },
                ],
                categoryForm: {
                    name: "",
                    order: 1,
                },
                editConditionModel:{
                    csFileConditionID:"",
                    showName:"",
                    isEnable:"",
                    sort:"",
                },
                conditionModel: {
                    createUserID:"",
                    showName:"",
                    fieldName:"dataType",
                    fieldValue:"",
                    fieldOp:"equal",
                    isEnable:true,
                    userDataType:"",
                    sort:"",
                },
            };
        },

        created() { this.searchList();},

        methods: {
            searchList(){
                let param={
                    includeChild:1
                };
                var maxValue=0;
                var maxSort=0;
                getConditionList(param).then((res) => {
                    this.tagsList=res.data;
                    for (var temp of res.data) {
                        if (temp.fieldValue > maxValue) {
                            maxValue = temp.fieldValue;
                        }
                        if(temp.sort>maxSort){
                            maxSort=temp.sort;
                        }
                    }
                    this.conditionModel.fieldValue=parseInt(maxValue)+1;
                    this.conditionModel.sort=parseInt(maxSort)+1;
                    console.log(this.tagsList);
                });
            },
            /**
             * 回退上一级
             */
            goBack() {
                this.$router.go(-1);
            },
            handleUpdateCondition(row){
                this.editDialogVisible=true;
                this.editConditionModel.level=row.level;
                this.editConditionModel.csFileConditionID=row.csFileConditionID;
                this.editConditionModel.showName=row.showName;
                this.editConditionModel.sort=row.sort;
                this.editConditionModel.isEnable=row.isEnable;
            },
            /**
             * 启用设置
             * @param csFileID 文件id
             * @param e true/false
             */
            onMarkChange(row,e){
                console.log(row);
                let params={
                    showName:row.showName,
                    sort:row.sort,
                    csFileConditionID:row.csFileConditionID,
                    isEnable:e,
                };
                updateCondition(params).then((res)=>{
                    console.log(res);
                    if(res.code===200){
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                    }
                });
            },
            /**
             * 删除记录
             */
            handleDeleteRow(){

            },

            //更新筛选条件
            editCondition(){
                let params={
                    csFileConditionID:this.editConditionModel.csFileConditionID,
                    showName:this.editConditionModel.showName,
                    sort:this.editConditionModel.sort,
                };
                updateCondition(params).then((res)=>{
                    console.log(res);
                    if(res.code===200){
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                    }
                    this.editDialogVisible = false;
                    this.searchList();
                });
            },

            addCondition(){
                let params={}
                params.level=0;
                params.showName=this.conditionModel.showName;
                params.fieldName=this.conditionModel.fieldName;
                params.fieldOp=this.conditionModel.fieldOp;
                params.fieldValue=this.conditionModel.fieldValue;
                params.isEnable=this.conditionModel.enable;
                params.userDataType=this.conditionModel.userDataType;
                params.sort=this.conditionModel.sort;
                params.type=0;
                params.fieldOp='equal';
                if(this.level===0) {
                    params.parentID = 0;
                }
                else if(this.level===1) {
                    params.parentID = this.chosenTag.csFileConditionID;
                }
                addCondition(params).then((res)=>{
                    console.log(res);
                    if(res.code===200){
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                    }
                    else if(res.code===403){
                        this.$message({
                            message: res.message,
                            type: "Warning",
                        });
                    }
                    this.conditionDialogVisible = false;
                    this.searchList();
                });
            },
        },
    };
</script>


<style scoped>
</style>